/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Show_DetailsInputs */



/**
* | output |
* | --- |
* | "Show details" |
*
* @param {Error_Show_DetailsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_show_details = /** @type {((inputs?: Error_Show_DetailsInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Show_DetailsInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Details anzeigen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher les détails")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("显示详情")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("顯示詳細資訊")
	if (locale === "ko") return /** @type {LocalizedString} */ ("상세 정보 보기")
	return /** @type {LocalizedString} */ ("Show details")
});